import api from '../../api/apiClient';
import type { MenuAction, MenuEntry } from '../../auth/access';

/**
 * Role-wise menu access (V30), admin side: the menu catalogue, the roles and their grants, and
 * which role each login has. See AccessController on the API.
 */

export interface AccessRole {
  code: string;
  label: string;
  description: string | null;
  system: boolean;
  userCount: number;
  /** menu code → granted actions (VIEW first) */
  grants: Record<string, MenuAction[]>;
}

export interface AccessUser {
  id: number;
  name: string;
  username: string;
  role: string | null;
}

async function data<T>(p: Promise<{ data: { data: T } }>): Promise<T> {
  return (await p).data.data;
}

export const accessApi = {
  menus: () => data<MenuEntry[]>(api.get('/api/access/menus')),
  roles: () => data<AccessRole[]>(api.get('/api/access/roles')),
  createRole: (body: { code: string; label: string; description?: string | null }) =>
    data<AccessRole>(api.post('/api/access/roles', body)),
  updateRole: (code: string, body: { label: string; description?: string | null }) =>
    data<AccessRole>(api.put(`/api/access/roles/${code}`, body)),
  deleteRole: (code: string) => api.delete(`/api/access/roles/${code}`),
  saveGrants: (code: string, grants: { menuCode: string; actions: MenuAction[] }[]) =>
    data<AccessRole>(api.put(`/api/access/roles/${code}/grants`, { grants })),
  users: () => data<AccessUser[]>(api.get('/api/access/users')),
  assignRole: (userId: number, role: string | null) => data<AccessUser>(api.put(`/api/access/users/${userId}/role`, { role })),
};
